import type { RateRepository } from '@/core/rate'
import type { UseCase } from '@/core/shared'

export const getIsRateAssigned: UseCase<RateRepository, 'getIsRateAssigned'> = repository => {
  return async (groupUid, rateUid) => {
    return await repository.getIsRateAssigned(groupUid, rateUid)
  }
}
